import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
 
function MyDropzone(props) {
  const onDrop = useCallback(acceptedFiles => {
    const reader = new FileReader()
    reader.onabort = () => console.log('file reading was aborted')
    reader.onerror = () => console.log('file reading has failed')
    reader.onload = () => console.log('Reader files onload: ' +JSON.stringify(reader.result));
      props.getUploadedFile(acceptedFiles);
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
 
  //Browse a file
  return (
    <div {...getRootProps()} className="drg_containeraudio">
      <input {...getInputProps()} accept="audio/mp3,audio/wav"/>    
      <button>BROWSE</button>
    </div>
  )
}

 export default MyDropzone;


// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/dragNdDrop.js